import React, { memo } from 'react';
import { Stack, Typography, Icon, Tooltip, Divider } from 'investira.react.components';
import { displays } from 'investira.react.lib';

const AvaliacoesOutputResumo = memo(props => {
  const { gestor, nota = 0 } = props;

  console.log(gestor);

  const addressToString = pEndereco => {
    if (!pEndereco) {
      return null;
    }

    const { bairro = '', cep = '', cidade = '', complemento = '', logradouro = '' } = pEndereco;

    const xEndereco = `${logradouro || ''} ${complemento || ''}, ${bairro || ''}, ${
      cidade || ''
    } - ${displays.cep(cep)}`;

    return xEndereco;
  };

  const dadosGestorMock = [
    { label: 'Razão social', value: 'Alpha Asset Management Ltda.' },
    { label: 'CNPJ', value: '12.345.678/0001-90' },
    { label: 'Fundação', value: '2012-08-15' },
    { label: 'Site', value: 'https://www.alphaasset.com.br' },
    { label: 'Telefone', value: '(11) 4000-1000' },
    { label: 'Endereço', value: 'Av. Paulista, 1000 - São Paulo/SP' }
  ];

  const dadosGestor = [
    { label: 'Razão social', value: gestor?.pessoa },
    { label: 'CNPJ', value: gestor?.cnpj },
    { label: 'Fundação', value: gestor?.juridica?.constituicao },
    { label: 'Site', value: gestor?.infos?.site },
    { label: 'Telefone', value: gestor?.infos?.telefone },
    { label: 'Endereço', value: addressToString(gestor?.endereco) }
  ];

  const dadosGestorExibicao = dadosGestor.length > 0 ? dadosGestor : dadosGestorMock;

  return (
    <Stack direction="row" gap={4}>
      <Stack>
        <Stack gap={2} direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Stack direction="row" gap={2} alignItems="baseline">
            <Tooltip title="Resumo gerado por IA" placement="top">
              <span>
                <Icon iconName="text_ia" size={21} color="primary" />
              </span>
            </Tooltip>
            <Typography variant="h6" color="textPrimary">
              Resumo
            </Typography>
          </Stack>
        </Stack>
        <Typography variant="body2" color="textPrimary" gutterBottom>
          Sob a ótica da avaliação quantitativa o fundo apresentou <b>[forte / modesto / fraco]</b>{' '}
          desempenho nos últimos <b>[36 / 24 / 12]</b> meses, obtendo a{' '}
          <b>___ª colocação no ranking de ___ fundos de sua categoria</b>. Isto resultou em uma nota
          de avaliação quantitativa de <b>___ [mínima 0 e máxima 3]</b>.
        </Typography>
        <Typography variant="body2" color="textPrimary" gutterBottom>
          Doponto de vista da avaliação qualitativa, o fundo demostra{' '}
          <b>[forte / modesta / fraca]</b>
          capacidade de cumprimento do dever fiduciário, com <b>[pleno / razoável / baixa]</b>{' '}
          garantia de tratamento de conflitos de interesses e observância a aspectos ASG e
          fundamentado em regulamento que assegura{' '}
          <b>[plenamente / razoavelmente / insatisfatoriamente]</b> o atendimento dos interesses do
          cotista. A nota de avaliação qualitativa obtida foi <b>___ [mínima 0 e máxima 3]</b>." “No
          geral, o fundo obteve nota <b>___ [mínima 0 e máxima 3]</b>."
        </Typography>
        <Typography variant="body2" color="textPrimary" gutterBottom>
          De acordo com o resultado geral, a seguinte possibilidade deve ser considerada:
        </Typography>
        <Stack gap={1.5}>
          <Stack
            sx={{
              pl: 3,
              borderLeft: '4px solid',
              borderColor:
                nota < 2
                  ? 'error.main'
                  : nota < 3.5
                  ? 'warning.main'
                  : nota < 4
                  ? 'info.main'
                  : 'primary.main',
              px: 2
            }}>
            <Typography variant="body2" color="textPrimary">
              Alocação no fundo sem restrições, observados os limites regulamentares.
            </Typography>
          </Stack>
          <Stack
            sx={{
              pl: 3,
              borderLeft: '4px solid',
              borderColor:
                nota < 2
                  ? 'error.main'
                  : nota < 3.5
                  ? 'warning.main'
                  : nota < 4
                  ? 'info.main'
                  : 'primary.main',
              px: 2
            }}>
            <Typography variant="body2" color="textPrimary">
              Alocação no fundo com restrições definidas pela instância devida da EFPC.{' '}
            </Typography>
          </Stack>
          <Stack
            sx={{
              pl: 3,
              borderLeft: '4px solid',
              borderColor:
                nota < 2
                  ? 'error.main'
                  : nota < 3.5
                  ? 'warning.main'
                  : nota < 4
                  ? 'info.main'
                  : 'primary.main',
              px: 2
            }}>
            <Typography variant="body2" color="textPrimary">
              Vedação a alocações, avaliando desinvestimento do fundo.
            </Typography>
          </Stack>
        </Stack>
      </Stack>
      <Divider orientation="vertical" flexItem />
      <Stack sx={{ minWidth: '200px', maxWidth: '340px', width: '100%' }}>
        <Stack gap={2} direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Stack direction="row" gap={2} alignItems="baseline">
            <Typography
              color="textSecondary"
              variant="caption"
              sx={{ textTransform: 'uppercase', fontWeight: 500 }}>
              Dados dos Gestor
            </Typography>
          </Stack>
        </Stack>
        <Stack gap={0.75}>
          {dadosGestorExibicao.map(item => (
            <Typography key={item.label} variant="body2" color="textPrimary" gutterBottom>
              <b>{item.label}:</b> {item.value}
            </Typography>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
});

export default AvaliacoesOutputResumo;
